import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Configuración real de LexoControl proporcionada por el usuario
const firebaseConfig = {
    apiKey: "AIzaSyB1ZvBFAOlwgQ-d3B8do5-m18oIQ4AekAw",
    authDomain: "controllegaltotal.com",
    projectId: "lexocontrol",
    storageBucket: "lexocontrol.firebasestorage.app",
    messagingSenderId: "261583176723",
    appId: "1:261583176723:web:06a9db58e0ffbfc393abe6"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
